module.exports = __webpack_public_path__ + "static/img/logoname.0619ed4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logoname.png
// module id = k+rL
// module chunks = 1